import { Button, Col, DatePicker, Form, Input, Modal, Row, Select, Space, theme } from "antd"
import React, { useEffect } from "react";
import {  requiredItem, TYPE_MODAL } from "../../../constants/constants";
import { filterOption, isAdmin } from "../../../utils/funcHelper";
import dayjs from "dayjs";
import { CloseOutlined, SaveOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

const ModalAddAndEdit = ({ visible, onCancel, onSave, data, title, type }) => {
    const [form] = Form.useForm();
    const { token } = theme.useToken();
    const userReducer = useSelector((state) => state.userReducer?.data);
    const formStyle = {
        maxWidth: 'none',
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        padding: 24,
    };
    const handleFinish = (values) => {
        console.log(values);
        if (onSave) {
            const params = {
                ...values,
                birthday: values?.birthday ? dayjs(values?.birthday).format("YYYY-MM-DD") : null,
            }
            if (type === TYPE_MODAL.EDIT) {
                params.id = data.id;
                params.updated_by = userReducer?.user_info?.id;
            } else {
                params.created_by = userReducer?.user_info?.id;
            }
            onSave(params);
        }
        
    };

    useEffect(() => {
        if (type === TYPE_MODAL.EDIT) {
            form.setFieldsValue({
                ...data,
                birthday: data?.birthday ? dayjs(data?.birthday) : null,
            });
            
        } else {
            form.resetFields();
        }
    }, [data, type, visible]);

    return (
        <Modal
            title={title}
            open={visible}
            onCancel={onCancel}
            width={'80%'}
            footer={null}
        >
            <Form form={form} layout="vertical" name="add-edit-account" style={formStyle} onFinish={handleFinish}>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item
                            label="Họ và tên"
                            name="full_name"
                            rules={requiredItem}
                        >
                            <Input 
                                disabled={!isAdmin(userReducer)}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            label="Số điện chính"
                            name="phone"
                            rules={requiredItem}
                        >
                            <Input 
                                disabled={!isAdmin(userReducer)}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={5}>
                        <Form.Item
                            label="Số điện khác"
                            name="other_phone"
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={5}>
                        <Form.Item
                            label="CCCD"
                            name="cccd"
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item
                            label="Ngày sinh"
                            name="birthday"
                        >
                            <DatePicker style={{ width: '100%', height: 40 }} format={"DD/MM/YYYY"}/>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label="Giới tính"
                            name="gender"
                            rules={requiredItem}
                        >
                            <Select
                                placeholder="Chọn giới tính"
                                optionFilterProp="children"
                                filterOption={filterOption}
                                style={{ width: '100%', height: 40 }}
                            >
                                <Select.Option value="female">Nữ</Select.Option>
                                <Select.Option value="male">Nam</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label="Địa chỉ"
                            name="address"
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16} justify={'end'}>
                    <Space>
                        <Button onClick={onCancel} icon={<CloseOutlined />}>
                            Đóng
                        </Button>
                        <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
                            Lưu
                        </Button>
                    </Space>
                </Row>
            </Form>
        </Modal>
    )
}
export default React.memo(ModalAddAndEdit);